/* GridBaseComboboxEditor.js */

"use strict";
const _ = require("lodash");

class GridBaseComboBoxEditor {
    constructor(/*args*/) {}

    position(position) {
        let optionContainer = this.comboBox.renderer.rootElement.querySelector(".option-container");
        let style = "";
        style += " position: fixed;";
        style += " top: " + (position.top + position.height + 5) + "px;";
        style += " left: " + (position.left + 9) + "px;";
        style += " width: " + (position.width - 13) + "px;";
        optionContainer.setAttribute("style", style);
    }
}

module.exports = GridBaseComboBoxEditor;
